// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2gAp2","cell":"ColumnAccessor_cell__aTjf2","firstCellAccent":"ColumnAccessor_firstCellAccent__1CMnG"};